export const formatNumber = (numero = "") => {
    if (numero.length < 4) return numero;
    numero = numero.split(".").join("");
    const normalizedNumber = numero.split('').reverse().join('');

    // Se divide la cadena en grupos de tres caracteres y une con puntos
    const formattedNumber = normalizedNumber?.match(/.{1,3}/g)?.join('.');
    return formattedNumber.split('').reverse().join('');
}